import React, { useEffect, useState } from 'react';
import { FaUserCircle } from 'react-icons/fa';
import { MdOutlineAccessTime } from 'react-icons/md';
import axios from '../../utils/axios';
import Sidebar from './sidebar';

const Logins = () => {
  const [logins, setLogins] = useState([]);

  useEffect(() => {
    axios.get('/auth/login-time').then((res) => {
      setLogins(res.data);
    });
  }, []);

  return (
    <div className="flex h-screen bg-gray-100">
      <Sidebar />

      <main className="flex-1 p-6 overflow-y-auto">
        <div className="mb-6">
          <h1 className="text-3xl font-semibold text-gray-800 flex items-center gap-2">
            <MdOutlineAccessTime className="text-green-600" /> User Login History
          </h1>
          <p className="text-gray-500 mt-1">Track who logged in and when.</p>
        </div>

        <div className="bg-white shadow-lg rounded-lg overflow-auto">
          <table className="min-w-full text-sm text-left border border-gray-200">
            <thead className="bg-green-50 text-green-800 font-medium">
              <tr>
                <th className="px-6 py-3 border-b">#</th>
                <th className="px-6 py-3 border-b">Name</th>
                <th className="px-6 py-3 border-b">Username</th>
                <th className="px-6 py-3 border-b">Role</th>
                <th className="px-6 py-3 border-b">Last Login</th>
                <th className="px-6 py-3 border-b text-center">Login Count</th>
              </tr>
            </thead>
            <tbody className="text-gray-700">
              {logins.map((user, index) => (
                <tr
                  key={user.id}
                  className="border-t hover:bg-gray-50 transition duration-200"
                >
                  <td className="px-6 py-3">{index + 1}</td>
                  <td className="px-6 py-3 flex items-center gap-2">
                    <FaUserCircle className="text-gray-400 text-xl" />
                    {user.name || '—'}
                  </td>
                  <td className="px-6 py-3 font-medium">{user.username}</td>
                  <td className="px-6 py-3">
                    <span className="inline-block px-2 py-1 text-xs bg-blue-100 text-blue-800 rounded-full capitalize">
                      {user.role}
                    </span>
                  </td>
                  <td className="px-6 py-3">
                    {user.last_login
                      ? new Date(user.last_login).toLocaleString()
                      : <span className="text-gray-400 italic">Never</span>}
                  </td>
                  <td className="px-6 py-3 text-center">{user.login_count}</td>
                </tr>
              ))}

              {logins.length === 0 && (
                <tr>
                  <td colSpan="6" className="text-center py-6 text-gray-500 italic">
                    No login records found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </main>
    </div>
  );
};

export default Logins;
